<script>
import { mapState, mapActions } from 'vuex';
import { setToken } from '@/scripts/axios';
import { oauthGetToken, getProfile } from '@/scripts/api/account';
import { goTo, errorCloseCallback, handleError } from '@/scripts/methods';
import { clearAll } from '@/scripts/utils/store-dependent';
import { wsConnection } from '@/scripts/modules/ws';

export default {
  name: 'Oauth',
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.fillDataFromUrl();
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.redirectId);
  },
  methods: {
    ...mapActions({
      setUser: 'setUser',
      setError: 'setError',
      setErrorCloseCallback: 'setErrorCloseCallback',
    }),
    fillDataFromUrl() {
      const { $route: route = null } = this;
      const oauthSystem = route.params.operator;
      /*  */
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
      const code = urlParams.get('code');
      const referrerID = localStorage.getItem('referrerID');
      const payload = {
        oauthSystem,
        state,
        code,
      };

      if (referrerID) payload.referrerID = referrerID;

      /* const scope = urlParams.get('scope');
      const prompt = urlParams.get('prompt'); */

      const { match, storedState } = this.checkStateMatching(state);

      if (!oauthSystem || !state || !code || !match) {
        console.warn(`payload = `);
        console.dir(payload);
        console.warn('storedState', storedState);
        clearAll();

        this.setError('Parameters not provided');

        /* async */
        this.redirectId = setTimeout(() => {
          /* TODO: turn off in tests */
          this.setError(null);
          this.goTo('/login');
        }, 5000);

        return;
      }

      this.payload = payload;
      this.register(payload);
    },
    register(payload = this.payload) {
      let redirect = '/dashboard';
      localStorage.removeItem('referrerID');

      return oauthGetToken(payload)
        .then(({ token, newAccount }) => {
          setToken(token);
          wsConnection.setToken(token);
          wsConnection.connect('users');

          localStorage.removeItem('oauthState');
          if (newAccount) redirect = '/onboarding';

          return getProfile();
        })
        .then(user => {
          this.setUser(user);
          /* TODO: conditional path (wait for api change)*/
          this.goTo(redirect);
        })
        .catch(this.handleError);
    },
    checkStateMatching(state) {
      const storedState = localStorage.getItem('oauthState', state);
      const match = state === storedState;

      return { match, storedState };
    },
    errorCloseCallback,
    handleError,
    goTo,
  },
};
</script>

<template>
  <div class="signup"></div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
</style>
